/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, forwardRef } from "react";
import { Input } from "@mui/material";

import styles from "./styles.module.scss";

type Props = {
  onChange: (newValue: string | undefined) => void;
  placeholder?: string;
  initialValue?: string;
  normalize?: ((value: string) => string)[];
  id?: string;
  disabled?: boolean;
  type?: string;
  autoComplete?: string;
  value: string | undefined;
};

const Textarea = forwardRef<HTMLInputElement, Props>(
  (
    {
      value,
      onChange,
      placeholder,
      initialValue,
      normalize,
      disabled,
      type = "text",
      autoComplete = "on",
      id
    },
    ref
  ) => {
    useEffect(() => {
      if (initialValue) onChange(initialValue);
    }, []);

    return (
      <div className={styles.container}>
        <Input
          value={value ?? ""}
          multiline
          disableUnderline
          ref={ref}
          id={id}
          autoComplete={autoComplete}
          disabled={disabled}
          placeholder={placeholder}
          classes={{ root: styles.input }}
          type={type}
          onChange={(event: any) => {
            const { value: newValue } = event.target;
            if (!newValue) onChange(undefined);
            else
              onChange(normalize?.reduce((acc, curr) => curr(acc), newValue));
          }}
        />
      </div>
    );
  }
);

Textarea.defaultProps = {
  placeholder: "",
  initialValue: undefined,
  normalize: [],
  disabled: false,
  type: "text",
  autoComplete: "on",
  id: undefined
};

export default Textarea;
